import React from 'react';
import { message } from 'antd';
import { useNavigate } from 'react-router-dom';
import Carousel from './Carousel';
import './Hero.css';

const Hero = () => {
    const navigate = useNavigate();

    const carouselImages = [
        {
            url: 'https://durker.com/lanying_files/rotate/banner1.jpg',
            title: '自然风景',
            description: '美丽的高山湖泊景色'
        },
        {
            url: 'https://durker.com/lanying_files/rotate/banner2.jpg',
            title: '城市夜景',
            description: '璀璨的城市灯光'
        },
        {
            url: 'https://durker.com/lanying_files/rotate/banner3.jpg',
            title: '森林徒步',
            description: '宁静的森林小径'
        },
        {
            url: 'https://durker.com/lanying_files/rotate/banner4.jpg',
            title: '海边日落',
            description: '浪漫的海滩日落时光'
        }
    ];

    const productExperience = () => {
        message.info("产品介绍");
    }

    const learnMore = () => {
        navigate('/Ai');
    }

    return <section id="home" className="hero-section">
        <div className="hero-content">
            <h2>蓝英科技</h2>
            <p className="hero-subtitle">打造卓越的数字体验，引领行业创新</p>
            <p className="hero-description">我们致力于为您提供最先进的技术解决方案，助力企业数字化转型，创造无限可能。</p>
            <div className="hero-buttons">
                <button className="btn btn-primary" onClick={productExperience}>产品介绍</button>
                <button className="btn btn-secondary" onClick={learnMore}>AI体验区</button>
            </div>
        </div>

        <div className="hero-carousel">
            <Carousel images={carouselImages} autoPlay={true} interval={4000} />
        </div>
    </section>
}

export default Hero;